/**
 * Feature Value module
 *
 * Heading contetn with large image or video below
 */

// Deps
import { createComponent } from "react-fela";
import { gutters } from "~/styleguide";
import { textStyles } from "~/styleguide/typography";
import { fluid } from "~/styleguide/utils";

import { ContentMaxWidth } from "~/components/layout/max-width";
import Visual from "~/components/shared/visual";

export default function HeadingContent({ block, isLcpCandidate }) {
    const { heading, copy, image, video = "", anchor_id } = block;

    if (!copy && !heading) return null;

    return (
        <Container id={anchor_id} className="module_heading module-feature-value">
            <ContentMaxWidth>
                {/* Heading  */}
                {heading && (
                    <Heading
                        extend={textStyles.heading2}
                        dangerouslySetInnerHTML={{
                            __html: heading
                        }}
                    />
                )}

                {/* Copy */}
                {copy && (
                    <Copy
                        dangerouslySetInnerHTML={{
                            __html: copy
                        }}
                        extend={copyStyles}
                    ></Copy>
                )}

                <Visual
                    deferVideoOnMobile
                    image={image}
                    isLcpCandidate={isLcpCandidate}
                    load={isLcpCandidate}
                    video={video ? video : ""}
                    autoplay
                    playsinline
                    muted
                    loop
                    extend={visualStyles}
                    background=""
                />
            </ContentMaxWidth>
        </Container>
    );
}

const Heading = createComponent(
    () => ({
        margin: "auto"
    }),
    "h3",
    ["dangerouslySetInnerHTML"]
);

const visualStyles = {
    width: "100%",
    maxWidth: "930px",
    margin: "auto",
    extend: [
        fluid("marginTop", {
            min: 30,
            max: 60
        })
    ],
    "& .vv-visual": {
        width: "100%"
    },
    "& video": {
        width: "100%"
    }
};

const Copy = createComponent(
    () => ({
        ...textStyles.paragraphLarge,
        marginH: "auto"
    }),
    "p",
    ["dangerouslySetInnerHTML"]
);

const copyStyles = {
    extend: [fluid("marginTop", { min: 20, max: 40 })]
};

const Container = createComponent(
    () => ({
        textAlign: "center",
        extend: [
            fluid("paddingV", gutters.vertical),
            fluid("paddingH", gutters.default)
        ]
    }),
    "div",
    ["id"]
);
